@for (measure of legacyMeasurementResults; track measure.id) {
  <div>{{ formatLegacyMeasurement(measure) }}</div>
  @if (measure?.result?.objectDistance) {
    <div>{{ "imageRemeasurementEdit.objectDistance" | translate }} {{ measure.result.objectDistance }} {{ measure?.unit }}</div>
  }
}

@for (measure of merryMeasurementResults(); track $index) {
  @let results = getResults(measure);

  <div class="measure-info">
    <span>{{ "measurement." + measure.type | translate }}:</span>
    @if (results.length === 1) {
      <div>
        {{ results[0].value | convert: unitSystem : results[0].unitType | number: precision() }}
        <span>{{ getUnitLabel(results[0].unitType) }}</span>
      </div>
    }
  </div>
  @if (results.length > 1) {
    @for (item of results; track $index) {
      <div class="measure-info measure-item">
        <span>{{ item.label | translate: item.labelParams }}:</span>
        <div>
          {{ item.value | convert: unitSystem : item.unitType | number: precision() }}
          <span>{{ getUnitLabel(item.unitType) }}</span>
        </div>
      </div>
    }
  }
}
